import MVT from 'ol/format/mvt';

export default {
	type: 'format',
	name: 'MVT',
	Constructor: MVT,
	optionMap: {},
};

